import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { RecommendationsSliderTypeKey } from 'corgi-types';
import type { Article } from 'graphql-ts-types';
import type { SpaceProps } from 'styled-system';
import { space } from 'styled-system';

import RecommendationsSlider from '../../../recommendations-slider/components/RecommendationsSlider';
import CartAlert from '../../components/CartAlert';
import { RecoSliderPosition } from '../../enums/RecommendationsSlider';

type CartDrawerContentsProps = ComponentProps<typeof CartAlert> & Pick<Article, 'sku'>;

const TEST_ID = 'cart-drawer-contents';
const FOOTER_HEIGHT_PX = '92px';

const Container = styled.div<SpaceProps>`
  ${space};
`;

const UnstyledStyledRecommendationsSlider = styled(RecommendationsSlider)<any>`
  ${space};
`;

const StyledRecommendationsSlider = (
  props: ComponentProps<typeof UnstyledStyledRecommendationsSlider>
) => (
  <UnstyledStyledRecommendationsSlider
    px={['sp_12', 'sp_16', null, 'sp_20']}
    mt="sp_16"
    {...props}
  />
);

const CartDrawerContents = ({ sku, ...props }: CartDrawerContentsProps) => (
  <Container data-testid={TEST_ID} pb={FOOTER_HEIGHT_PX}>
    <CartAlert {...props} />
    <StyledRecommendationsSlider
      type={RecommendationsSliderTypeKey.AddToCart}
      position={RecoSliderPosition.Drawer}
      sku={sku}
      withDiscountLabelBackButton
    />
  </Container>
);

export default CartDrawerContents;
